<template>
  <div class="multiple-main" v-loading="loading">
    <el-form label-width="86px">
      <el-form-item label="题目类型" prop="examName">
        <el-radio-group v-model="type" @input="radioChange" v-removeAriaHidden>
          <el-radio v-for="(radio, index) in questionType" :key="index" :label="radio.id">{{radio.name}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="适合专业">
        <el-checkbox-group v-model="formData.profession" @change="updateProfessionName">
          <el-checkbox :label="val.id" v-for="val in professionData" :key="val.id">{{val.dictionaryName}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div class="add-box">
      <el-upload
        class="upload-demo"
        drag
        :auto-upload="true"
        :action="commonServer.uploadExcel"
        :headers="{ Authorization: token }"
        :multiple="false"
        :on-success="uploadSuccess"
        :before-upload="uploadBefore"
        :show-file-list="false"
        :data="{type, profession: formData.profession.join(','), professionName: formData.professionName}">
        <div class="el-upload__text">
          将文件拖到此处，或<em>点击上传</em>
          <p>只能上传xlsx文件，且不超过10M</p>
        </div>
      </el-upload>
      <div class="err-msg-list" v-if="Array.isArray(resMsg)">
        <p>错误提示:</p>
        <p v-for="(v, i) in resMsg" :key="i">{{v}}</p>
      </div>
      <div class="success-msg" v-else-if="resMsg">{{resMsg}}</div>
    </div>
    <div class="table-desc">
      <span class="span-label">表格示例</span>
      <span class="span-label">
        <!-- <a> <i class="el-icon-download"></i>下载模板</a> -->
        <a :href="`/template/${questionType[type-1].name}模板.xlsx`" :download="`${questionType[type-1].name}模板.xlsx`" style="color: #409EFF"><i class="el-icon-download"></i>下载模板</a>
      </span>
      <p>1、可通过下载上方模板，进行数据导入</p>
      <p>
        <span>2、请检查表格内的信息是否符合以下要求：</span>
        <ul>
          <li>课程目录编号已在系统内创建</li>
          <li>空选项不可作为正确答案</li>
        </ul>
      </p>
    </div>
    <table-page :key="`_${new Date().getTime()}_${Math.random()}`"
      ref="table"
      size="mini"
      :isPagination="false"
      :tableData="tableData"
      :tableCols="tableCols"
      :pagination.sync="pagination"
    ></table-page>
  </div>
</template>

<script>
import Dialog from '@/components/common/Dialog';
import { questionType } from '@/data/data';
import { single, multiple, judge, sort, gap } from '../json/templateExample';
import deepCopy from '@/utils/deepcopy'
import tablePage from '@/mixin/table.js';
import { commonServer, keyServer } from '@/api/api'
export default {
  mixins: [tablePage],
  components: {
    Dialog
  },
  data() {
    return {
      commonServer,
      token: window.localStorage.getItem('token'),
      loading: false,
      questionType,
      professionData: [],
      type: 1,
      formData: {
        profession: [],
        professionName: ''
      },
      tableData: [],
      tableCols: [],
      resMsg: null
    };
  },
  methods: {
    radioChange (radio) {
      this.resMsg = null
      let tableCols = []
      let tableData = []
      if (radio === 1) {
        tableCols = deepCopy(single.tableCols)
        tableData = deepCopy(single.tableData)
      }
      if (radio === 2) {
        tableCols = deepCopy(multiple.tableCols)
        tableData = deepCopy(multiple.tableData)
      }
      if (radio === 3) {
        tableCols = deepCopy(judge.tableCols)
        tableData = deepCopy(judge.tableData)
      }
      if (radio === 4) {
        tableCols = deepCopy(sort.tableCols)
        tableData = deepCopy(sort.tableData)
      }
      if (radio === 5) {
        tableCols = deepCopy(gap.tableCols)
        tableData = deepCopy(gap.tableData)
      }
      this.tableCols = tableCols
      this.tableData = tableData
    },
    // 更新 professionName 方法
    updateProfessionName() {
      const selectedIds = this.formData.profession;
      const names = this.professionData
        .filter(item => selectedIds.includes(item.id))
        .map(item => item.dictionaryName);
      this.formData.professionName = names.join(',');
    },
    uploadHttpRequest () {},
    // 文件发生改变
    uploadChange (file, fileList) {
      // if (fileList.length > 0) {
      //   this.fileList = [fileList[fileList.length - 1]] // 展示最后一次选择的文件
      // }
      // this.loading = true
      // var formData = new FormData()
      // formData.append('file', file.raw)
      // formData.append('type', this.type)
      // questionServer.questionimport(formData).then(res => {
      //   const {code, data, message} = res
      //   this.loading = false
      //   if (code === '0') {
      //     this.resMsg = '所有题目均已符合录入标准，已上传成功！！！'
      //     this.$message.success(message)
      //   } else {
      //     console.log(message, 'message')
      //     this.resMsg = data ? data.errMsg : ''
      //     this.$message.error(message)
      //   }
      // }).catch(error => {
      //   this.$message(error)
      // })
    },
    /**
     * 上传结果处理
     * @function uploadSuccess
     * @param  {Object} response 上传返回结果
     */ 
    uploadSuccess (response) {
      this.loading = false
      const {code, data, message} = response
      if (code === '0') {
        this.resMsg = '所有题目均已符合录入标准，已上传成功！！！'
        this.$message.success(message)
      } else {
        this.resMsg = data ? data.errMsg : ''
        this.$message.error(message)
      }
    },
    /**
     * 上传前的判断
     * @function uploadBefore
     * @return {Boolean}
     */
    uploadBefore (response) {
      if (!response.name.includes('.xlsx')) {
        this.$message.error('只支持上传.xlsx文件')
        return false;
      }
      var fileSize = response.size / 1024 / 1024 < 10;// 控制大小修改50的值即可
      if (!fileSize) {
        this.$message.error(`文件大小不能超过10MB`)
        return false;
      }
      return true
      // return new Promise((resolve, reject) => {
      //   let reader = new FileReader()
      //   reader.readAsArrayBuffer(file)
      //   reader.onload = () => {
      //     let byteArray = new Uint8Array(reader.result)
      //     let res = ''
      //     let byte
      //     let step = 4
      //     let position = 128
      //     for (let i = 0; i < step; i++) {
      //       byte = byteArray[position + i]
      //       if (byte === 0) position += step
      //       res += String.fromCharCode(byte)
      //     }
      //     if (res === 'xlsx') {
            
      //       resolve(res)
      //     } else {
      //       this.$msg.error('不是xlsx文件')
      //       reject(new Error())
      //     }
      //   }
      // })
      // var fileSize = response.size / 1024 / 1024 < 10;// 控制大小修改50的值即可
      // if (!fileSize) {
      //   this.$message.error(`文件大小不能超过10MB`)
      //   return false;
      // }
    },
    /**
     * 上传异常处理
     * @function uploadError
     * @param  {Object|String} err 上传异常信息
     */
    uploadError () {},
    // 专业数据
    selectDataV1 () {
      keyServer.profession({
        dictionaryKey: 'profession'
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.professionData = data
          this.formData.profession = this.professionData.map(v => v.id)
          this.updateProfessionName()
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 初始化
    init () {
      this.resMsg = null
      this.tableCols = []
      this.tableData = []
      this.type = 1
      this.formData.profession = this.professionData.map(v => v.id)
      this.updateProfessionName()
      this.radioChange(1)
      this.formData.profession.push(this.professionData[0].id)
    }
  },
  created () {
    this.radioChange(1)
    this.selectDataV1()
  }
};
</script>
<style lang='scss'>
.multiple-main {
  text-align: left;
  .el-upload {
    width: 100%;
  }
  .el-upload-dragger {
    width: 100%;
    height: 120px;
    .el-icon-upload {
      margin: 16px 0 16px;
    }
  }
  .err-msg-list {
    line-height: 28px;
    margin-top: 6px;
    color: red;
  }
  .success-msg {
    margin-top: 6px;
    color: dodgerblue;
  }
  .el-upload__tip {
	font-size: 13px;
	color: #333;
	margin-top: 7px
  }
  .upload-demo {
    .el-upload__text {
      padding-top: 35px;
      font-size: 16px;
      line-height: 28px;
    }
  }
  .table-desc {
    margin-top: 10px;
    line-height: 28px;
    .span-label {
      font-size: 16px;
      display: inline-block;
      a {
        color: #409EFF;
        font-size: 15px;
        margin-left: 10px;
      }
      i {
        font-weight: bold;
      }
    }
    ul {
      margin-left: 40px;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/views/resource/page/MultipleAddquestion.vue